import { defineComponent } from 'vue';
export default defineComponent({
    name: 'NoStartModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        time: {
            type: String,
            default: ''
        },
        activeTab: {
            default: 'OMO',
            type: String
        }
    },
    computed: {
        tipInfo() {
            if (this.activeTab === 'INDIVIDUAL') {
                return '专题';
            }
            else if (this.activeTab === 'TEAM') {
                return '共学营';
            }
            else {
                return '训练营';
            }
        }
    },
    setup(props, cxt) {
        const stopPopup = event => {
            event.stopPropagation();
            event.preventDefault();
        };
        const closeModal = () => {
            cxt.emit('close', false);
        };
        return {
            closeModal,
            stopPopup
        };
    }
});
